import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Organization } from '@shared/types/organization.model';
import { LocalStorageService, StorageKeys } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class OrganizationContextService {
  private currentOrgSubject: BehaviorSubject<Organization | null>;
  currentOrg$;

  constructor(private storage: LocalStorageService) {
    const stored = this.storage.getItem<Organization>(StorageKeys.CurrentOrganization);
    this.currentOrgSubject = new BehaviorSubject<Organization | null>(stored);
    // Restoring from storage and re-confirming the same org after the org list loads both call
    // setCurrentOrg() with a new object reference for the same org — dedupe by id so every
    // subscriber (school selector, SchoolAccessScopeService, page components) doesn't re-fetch.
    this.currentOrg$ = this.currentOrgSubject.asObservable().pipe(
      distinctUntilChanged((a, b) => a?.id === b?.id),
    );
  }

  setCurrentOrg(org: Organization | null) {
    this.currentOrgSubject.next(org);
    if (org) {
      this.storage.setItem(StorageKeys.CurrentOrganization, org);
    } else {
      this.storage.removeItem(StorageKeys.CurrentOrganization);
    }
  }

  getCurrentOrg(): Organization | null {
    return this.currentOrgSubject.getValue();
  }

  getOrgTenantCode(): string | null {
    const org = this.getCurrentOrg();
    return org ? org.tenantId : null;
  }
  clear() {
    this.setCurrentOrg(null);
  }
}
